import { render, staticRenderFns } from "./ext-link.html?vue&type=template&id=3591619a&scoped=true&"
import script from "./ext-link.js?vue&type=script&lang=js&"
export * from "./ext-link.js?vue&type=script&lang=js&"
import style0 from "./ext-link.scss?vue&type=style&index=0&id=3591619a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3591619a",
  null
  
)

export default component.exports